import React, { useEffect, useState } from "react";
import { Button, Card, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import DefaultLayout from "../../components/layout/DefaultLayout";
import "./blogs.css";
import blogApi from "../../apis/blogApi";
import { fetchBlogsAction } from "./blogAction";

export const Blogs = () => {
  const navigate = useNavigate(); // v6
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { blogs } = useSelector((state) => state.blog);

  const [activeFilter, setActiveFilter] = useState("All Blogs");
  const [blogList, setBlogList] = useState([]);

  const _id = user?._id;

  useEffect(() => {
    dispatch(fetchBlogsAction());
  }, [dispatch]);

  useEffect(() => {
    setBlogList(blogs);
  }, [blogs]);

  const handleBlogFilter = (filter) => {
    setActiveFilter(filter);
    if (filter === "My Blogs") {
      setBlogList(blogs.filter((blog) => blog.authorId === _id));
    } else {
      setBlogList(blogs);
    }
  };

  const handleOnDelete = async (blogId) => {
    if (!blogId) return;

    if (window.confirm("Are you sure you want to delete this blog?")) {
      const res = await blogApi.deleteABlog(blogId);
      if (res.status === "success") {
        dispatch(fetchBlogsAction());
      }
    }
  };

  return (
    <DefaultLayout>
      <Container>
        <Row className="d-flex justify-content-between align-items-center">
          <h1>Blogs</h1>
          <Button
            onClick={() => navigate("/blog/create")}
            className="btn-warning px-4"
            style={{ letterSpacing: "1px" }}
          >
            Create New Blog
          </Button>
        </Row>
        <hr />

        <Row>
          <div className="blogs-filter">
            {["All Blogs", "My Blogs"].map((item, i) => (
              <div
                key={i}
                className={`blog-filter-item ${
                  activeFilter === item ? "item-active" : ""
                }`}
                onClick={() => handleBlogFilter(item)}
              >
                {item}
              </div>
            ))}
          </div>
        </Row>

        <Row className="blogs-container">
          {blogList.map((blog, i) => (
            <Card className="blog-card" key={i}>
              <i
                className="fa-solid fa-circle-xmark blog-delete"
                onClick={() => handleOnDelete(blog._id)}
              ></i>

              <Link to={`/blog/${blog.slug}`}>
                <Card.Img
                  variant="top"
                  src={blog.image}
                  className="blog-image"
                />
              </Link>

              <Card.Body className="blog-card-body">
                <div className="d-flex flex-column justify-content-between my-3">
                  <Card.Title>{blog.title}</Card.Title>
                  <Card.Text>
                    {new Date(blog.createdAt).toDateString()}
                  </Card.Text>

                  <div className="d-flex justify-content-between mt-4">
                    <div>
                      <strong>Author</strong>
                      <div>{blog.authorName}</div>
                    </div>
                    <div>
                      <strong>Edited By</strong>
                      <div>{blog.editedBy}</div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))}
        </Row>
      </Container>
    </DefaultLayout>
  );
};
